import { OrderResponseProps, OrderReportState } from "./types";
import { createSlice } from "@reduxjs/toolkit";
import { getList } from "./orderReportService";
// create user
export const initialState: OrderReportState = {
  data: {} as OrderResponseProps,
  status: "loading",
  error: {},
};

export const OrderReportSlice = createSlice({
  name: "Order",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getList.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getList.fulfilled, (state, action) => {
        if (action.payload) {
          state.data = action.payload.data;
          state.status = action.payload.status;
          state.error = action.payload.error;
        }
      })
      .addCase(getList.rejected, (state, action) => {
        state.status = "error";
        state.error = action.error;
      });
  },
});

export const OrderReportReducer = OrderReportSlice.reducer;
